import React from 'react'

import { LoggedOutBoxSummaryModal } from '@features/box-summary'

import type { BoxSummaryTreatmentProps } from './props'
import { useLoggedOutBoxSummaryController } from './useLoggedOutBoxSummaryController'

export const BoxSummaryTreatment = (props: BoxSummaryTreatmentProps) => {
  const controller = useLoggedOutBoxSummaryController(props)

  return <LoggedOutBoxSummaryModal controller={controller} />
}
